import { render, staticRenderFns } from "./LearnerResultsSummary.vue?vue&type=template&id=6a09df6c&scoped=true"
import script from "./LearnerResultsSummary.vue?vue&type=script&lang=js"
export * from "./LearnerResultsSummary.vue?vue&type=script&lang=js"
import style0 from "./LearnerResultsSummary.vue?vue&type=style&index=0&id=6a09df6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09df6c",
  null
  
)

export default component.exports